import React from "react";
import { SpaceProps } from "styled-system";
import { Title } from "../Title";

interface Props {
  value: string;
  opacity?: number;
  fontSize?: number;
}

export const VectorFooterSectionTitle: React.FC<Props & SpaceProps> = ({ value, opacity, fontSize, ...restProps }) => (
  <Title as="h5" color="white" fontWeight="normal" fontSize={fontSize} opacity={opacity} my={[3, 2]} {...restProps}>
    {value}
  </Title>
);

VectorFooterSectionTitle.defaultProps = {
  opacity: 0.6,
  fontSize: 1,
};
